'use client'

import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'

type StatsConfig = {
  labelKey: string
  valueKey: string
}

type ResourceCardProps = {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  titleKey: string
  createPath: string
  listPath: string
  createLabelKey: string
  statsKey: string
  statsConfig: StatsConfig[]
  stats: any
  className?: string
}

const ResourceCard: React.FC<ResourceCardProps> = ({
  Icon,
  titleKey,
  createPath,
  listPath,
  createLabelKey,
  statsKey,
  statsConfig,
  stats,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`px-6 py-4 rounded-lg border border-gray-200 ${className}`}>
      <div className='flex justify-between items-center'>
        <div className='flex gap-6 items-center'>
          <div className='flex justify-center items-center w-8 h-8 bg-[#A595F0] rounded-full'>
            <Icon className='w-5 h-5 text-white' />
          </div>
          <h3 className='text-lg font-medium text-gray-900 truncate'>
            {t(titleKey)}
          </h3>
        </div>
        {createPath && createLabelKey && (
          <div>
            <Link href={createPath}>
              <Button type='link' icon={<PlusOutlined />} size='middle'>
                {t(createLabelKey)}
              </Button>
            </Link>
          </div>
        )}
      </div>
      <ul className='flex gap-6 justify-around items-center pt-6 pb-4'>
        {statsConfig.map((config, index) => (
          <li key={index} className='flex flex-col gap-2 items-center'>
            <span className='text-base text-gray-400 truncate'>
              {t(config.labelKey)}
            </span>
            <Link href={listPath} className='text-xl truncate text-primary-600'>
              {stats?.[statsKey]?.[config.valueKey] ?? 0}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ResourceCard
